import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// firebase init goes here
const config = {
    apiKey: "AIzaSyANUi_0Ou0xDRLNZgfALwjfH4jC70oNC6Q",
    authDomain: "reflektor-gogrow.firebaseapp.com",
    databaseURL: "https://reflektor-gogrow.firebaseio.com",
    projectId: "reflektor-gogrow",
    storageBucket: "reflektor-gogrow.appspot.com",
    messagingSenderId: "661228853690"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
    timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js